import { t } from "i18next";
import * as React from "react";
import styles from "./PlmUploader.module.less";

interface PropsUploadInfo {
  maxCount: number;
  accept?: string;
  maxSize?: number;
}

export const UploadInfo: React.FC<PropsUploadInfo> = (props) => {
  const { maxCount, accept, maxSize } = props;
  return (
    <div className={styles.uploadInfo}>
      <div>{accept && t("Format: value", { value: accept })}</div>
      <div>{maxCount && t("Maximum number: count", { count: maxCount })}</div>
      <div>{maxSize && t("Maximum total size:", { size: maxSize })}</div>
    </div>
  );
};
